import {InitPageStrict} from "../index";

declare var deleteNotePath: string;
declare var createNotePath: string;
declare var transactionId: number;
declare var canDeleteNotes: boolean;

interface ApiResponse {
    success: boolean;
    message: string;
    note?: {
        id: number;
        note: string;
        important: boolean;
        created_at: string;
        user_name: string;
    };
}

class SalesOrdersShow {
    private reviewLoading = false;

    constructor() {
        this.bindEvents();
    }

    private bindEvents(): void {

        // Note deletion
        $(document).on('click', '.delete-sales-order-note', (e: JQuery.ClickEvent) => {
            this.handleDeleteNote(e);
        });

        // Note creation
        $('#createSalesOrderNoteBtn').on('click', (e: JQuery.ClickEvent) => {
            this.handleCreateNote(e);
        });

        $('#shippedStatusReviewTrigger').on('click', () => {
            this.openShippedStatusReview();
        });

        $(document).on('change', '#markShippedConfirm', (e: JQuery.ChangeEvent) => {
            $('#markShippedBtn').prop('disabled', !$(e.currentTarget).is(':checked'));
        });

        $(document).on('click', '#markShippedBtn', (e: JQuery.ClickEvent) => {
            this.handleMarkShipped(e);
        });

    }

    private openShippedStatusReview(): void {
        if (this.reviewLoading) {
            return;
        }

        this.reviewLoading = true;
        const url = $('#shippedStatusReviewTrigger').data('review-url') as string;
        const $content = $('#shippedStatusReviewContent');

        $content.html('<div class="modal-body text-center pad20px"><i class="fa fa-spinner fa-spin fa-2x"></i><br/>Checking Senitron, NetSuite and Shopify...</div>');
        $('#shippedStatusReviewModal').modal('show');

        $.ajax({
            url: url,
            type: 'GET',
            success: (html: string) => {
                $content.html(html);
            },
            error: () => {
                $('#shippedStatusReviewModal').modal('hide');
                window.toastr_notifications.error('Failed to load the shipped status review.');
            },
            complete: () => {
                this.reviewLoading = false;
            }
        });
    }

    private handleMarkShipped(e: JQuery.ClickEvent): void {
        e.preventDefault();

        const $btn = $(e.currentTarget);
        if (!$('#markShippedConfirm').is(':checked')) {
            return;
        }

        $btn.prop('disabled', true);
        $btn.html('<i class="fa fa-spinner fa-spin"></i> Updating...');

        $.ajax({
            url: $btn.data('mark-url') as string,
            type: 'POST',
            success: () => {
                window.location.reload();
            },
            error: (xhr: JQuery.jqXHR) => {
                const response = xhr.responseJSON as ApiResponse;
                window.toastr_notifications.error((response && response.message) || 'Failed to update the status.');
                $btn.prop('disabled', false);
                $btn.html('Set Status to Shipped');
            }
        });
    }

    private handleDeleteNote(e: JQuery.ClickEvent): void {
        e.preventDefault();

        const noteId = $(e.currentTarget).data('note-id') as number;
        const $row = $(e.currentTarget).closest('tr');

        (window as any).swal({
            title: 'Are you sure?',
            text: 'This operation will delete the current note',
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((willDelete: boolean) => {
            if (willDelete) {
                $.ajax({
                    url: deleteNotePath,
                    type: 'DELETE',
                    data: {
                        note_id: noteId,
                        transaction_id: transactionId
                    },
                    success: (response: ApiResponse) => {
                        if (response.success) {
                            // Remove the row from the table
                            $row.fadeOut(300, function() {
                                $(this).remove();

                                // Check if there are no more notes and show empty message
                                if ($('#waveNotesTBody tr').length === 0) {
                                    const emptyRow = '<tr class="center-content">' +
                                        '<td colspan="5" class="text-center text-muted">No notes available</td>' +
                                        '</tr>';
                                    $('#waveNotesTBody').append(emptyRow);
                                }
                            });

                            window.toastr_notifications.success('Note deleted successfully!');
                        } else {
                            window.toastr_notifications.error(response.message || 'Failed to delete note.');
                        }
                    },
                    error: (xhr: JQuery.jqXHR) => {
                        const errorMsg = 'Failed to delete note.';
                        const response = xhr.responseJSON as ApiResponse;
                        if (response && response.message) {
                            window.toastr_notifications.error(response.message);
                        } else {
                            window.toastr_notifications.error(errorMsg);
                        }
                    }
                });
            }
        });
    }

    private handleCreateNote(e: JQuery.ClickEvent): void {
        e.preventDefault();

        const $btn = $('#createSalesOrderNoteBtn');
        const noteText = $('#salesOrderNoteFormMessage').val() as string;
        const important = $('#salesOrderNoteFormImportant').is(':checked');

        if (!noteText || noteText.trim() === '') {
            window.toastr_notifications.warning('Please enter a note.');
            return;
        }

        // Set loading state
        $btn.prop('disabled', true);
        $btn.html('<i class="fa fa-spinner fa-spin"></i> Adding...');

        $.ajax({
            url: createNotePath,
            type: 'POST',
            data: {
                note: noteText,
                important: important,
                transaction_id: transactionId
            },
            success: (response: ApiResponse) => {
                if (response.success && response.note) {
                    // Create new row HTML matching the new table structure
                    const importantIcon = response.note.important ? '<i class="fa fa-check text-danger"></i>' : '';
                    const dateTimeParts = response.note.created_at.split(' ');
                    const deleteIcon = canDeleteNotes 
                        ? `<a href="#" class="fa fa-trash-o fa-2x delete-icon delete-sales-order-note" title="Delete" data-toggle="tooltip" data-note-id="${response.note.id}"></a>` 
                        : `<span class="fa fa-trash-o fa-2x text-muted" style="cursor: not-allowed; opacity: 0.5;" title="You do not have permission to delete notes" data-toggle="tooltip"></span>`;
                    const newRow = `<tr class="center-content" data-note-id="${response.note.id}">` +
                        `<td class="heighter double-lines-content">` +
                        `${dateTimeParts[0]}<br/>${dateTimeParts[1]} ${dateTimeParts[2]}` +
                        `</td>` +
                        `<td style="text-align: left !important;">` +
                        `<span class="hover-cursor-pointer" title="${response.note.note}" data-toggle="tooltip" data-placement="top">` +
                        `${response.note.note.length > 80 ? response.note.note.substring(0, 80) + '...' : response.note.note}` +
                        `</span>` +
                        `</td>` +
                        `<td>${importantIcon}</td>` +
                        `<td>${response.note.user_name}</td>` +
                        `<td class="sn-icons">${deleteIcon}</td>` +
                        `</tr>`;

                    // Remove "No notes available" row if it exists
                    $('#salesOrderNotesTBody tr td[colspan="5"]').parent().remove();

                    // Prepend new note to table
                    $('#salesOrderNotesTBody').prepend(newRow);

                    // Clear form and close modal
                    $('#salesOrderNoteFormMessage').val('');
                    $('#salesOrderNoteFormImportant').prop('checked', false);
                    $('#addSalesOrderNote').modal('hide');

                    window.toastr_notifications.success('Note added successfully!');
                } else {
                    window.toastr_notifications.error(response.message || 'Failed to create note.');
                }
            },
            error: (xhr: JQuery.jqXHR) => {
                const errorMsg = 'Failed to create note.';
                const response = xhr.responseJSON as ApiResponse;
                if (response && response.message) {
                    window.toastr_notifications.error(response.message);
                } else {
                    window.toastr_notifications.error(errorMsg);
                }
            },
            complete: () => {
                // Reset button state
                $btn.prop('disabled', false);
                $btn.html('Add');
            }
        });
    }
}

declare global {
    interface Window {
        SalesOrdersShow: SalesOrdersShow;
    }
}

export function LoadPage(): void {
    InitPageStrict("transactions show", () => {
        window.SalesOrdersShow = new SalesOrdersShow();
    });
}